export { default } from '../../tngPassthrough/TngPage'
export { tngPageHandler as getServerSideProps } from '../../tngPassthrough/tngPageHandler'
